import { Injectable } from "@angular/core";
import { Store } from '@ngrx/store';
import { Observable, shareReplay } from 'rxjs';

import { Employee } from '@shared/classes/employee.class';
import { EmployeeState } from "./employees.reducer";
import {
  selectActiveEmployee,
  selectEmployeeByUuid,
  selectEmployees,
  selectLoadingStatusEmployees,
} from './employees.selectors';
import {
  ClearActiveEmployee,
  LoadListEmployeesFromLocalDB,
  SelectActiveEmployee,
  UpdateListEmployees,
} from './employees.actions';

import { map } from 'rxjs/operators';

@Injectable()
export class EmployeesFacadeStore {
  public readonly employees$: Observable<Employee[]> = this.store.select(selectEmployees)
    .pipe(
      map((employees: Employee[]): Employee[] =>
      [...employees].sort((a: Employee, b: Employee): number => {
        const aFirstName = a.firstName || '';
        const bFirstName = b.firstName || '';
        return aFirstName.localeCompare(bFirstName)
      })),
      shareReplay({ bufferSize: 1, refCount: true })
    );

  public readonly isLoading$: Observable<boolean> = this.store.select(selectLoadingStatusEmployees);

  public readonly activeEmployee$: Observable<Employee> = this.store.select(selectActiveEmployee);

  private readonly activeEmployeeSignal = this.store.selectSignal(selectActiveEmployee);

  constructor(private store: Store<EmployeeState>) {
  }

  public get activeEmployeeSnapshot(): Employee | null {
    return this.activeEmployeeSignal() ?? null;
  }

  public set selectActiveEmployee(employee: Employee) {
    this.store.dispatch(SelectActiveEmployee({ employee }));
  }

  public set activeEmployee(employee: Employee) {
    this.store.dispatch(SelectActiveEmployee({ employee }));
  }

  public getEmployeeByUuid$(uuid: string): Observable<Employee> {
    return this.store.select(selectEmployeeByUuid(uuid));
  }

  public loadEmployees(): void {
    this.store.dispatch(LoadListEmployeesFromLocalDB());
  }

  public updateEmployees(data: Employee[]): void {
    this.store.dispatch(UpdateListEmployees({ data }));
  }

  public clearActiveEmployee(): void {
    this.store.dispatch(ClearActiveEmployee());
  }
}
